import { connect } from 'react-redux';
import { FieldArray, FieldArrayFieldsProps, formValueSelector } from 'redux-form';
import { getGlobalLegalEntityIdentifiers } from '@mews-commander/core/legacy-globalization';
import { Entities } from '@mews-commander/legacy-entities/src/ducks/utils';
import { ApplicationState, LegalEntityIdentifier } from '@mews-commander/types';
import { LocalizedSectionTitle } from '@mews-commander/ui';
import { notEmpty } from '@mews-commander/utils';
import { TextKey } from '@mews-commander/enums';
import { InputField } from '../reduxFields';

export const LEGAL_ENTITY_IDENTIFIERS = 'legalEntityIdentifiers';

interface LegalEntityIdentifiers {
    [LEGAL_ENTITY_IDENTIFIERS]: Array<Record<string, string | null>>;
}

interface RenderLegalEntityIdentifiersFieldsProps {
    fields: FieldArrayFieldsProps<Record<string, string | null>>;
    legalEntityIdentifiersMap: Entities<LegalEntityIdentifier>;
}

const renderLegalEntityIdentifiersFields = ({
    fields,
    legalEntityIdentifiersMap,
}: RenderLegalEntityIdentifiersFieldsProps) =>
    fields.map((_, index) => {
        const field = fields.get(index);
        const key = Object.keys(field)[0];
        const name = `${LEGAL_ENTITY_IDENTIFIERS}[${index}].${key}`;
        const label = legalEntityIdentifiersMap?.[key]?.label;
        return <InputField key={key} name={name} label={label} />;
    });

export interface ContactFieldsProps {
    legalEntityIdentifiers: LegalEntityIdentifiers;
    legalEntityIdentifiersMap: Entities<LegalEntityIdentifier>;
}

const LegalEntityIndentifiersFields = ({ legalEntityIdentifiers, legalEntityIdentifiersMap }: ContactFieldsProps) => (
    <>
        {notEmpty(legalEntityIdentifiers) ? (
            <>
                <LocalizedSectionTitle textKey={TextKey.LegalIdentifierPlural} />
                <FieldArray
                    name={LEGAL_ENTITY_IDENTIFIERS}
                    // @ts-expect-error $TSFixMeError: No overload matches this call.
                    component={renderLegalEntityIdentifiersFields}
                    props={{ legalEntityIdentifiersMap }}
                />
            </>
        ) : null}
    </>
);

interface OwnProps {
    form: string;
}

export default connect<ContactFieldsProps, {}, OwnProps, ApplicationState>((state, { form }) => ({
    legalEntityIdentifiers: formValueSelector(form)(state, LEGAL_ENTITY_IDENTIFIERS),
    legalEntityIdentifiersMap: getGlobalLegalEntityIdentifiers(state),
}))(LegalEntityIndentifiersFields);
